import vue from "vue";

export default {
    SET_TITLE: (state, title) => {
        state.title = title;
    },
    SET_SERVICE_GROUPS: (state, sections) => {
        state.serviceGroups = sections;
    },
    SET_SERVICE_GROUP: (state, section) => {
        state.serviceGroup = section;
    },
    SET_STATUS: (state, status) => {
        state.status = status;
    },
    SET_SERVICE_GROUPS_TO_EDIT: (state, serviceGroupsToEdit) => {
        state.serviceGroupsToEdit = serviceGroupsToEdit;
    },
    SET_ACTIVE_SERVICE_GROUPS: (state, activeServiceGroups) => {
        state.activeServiceGroups = activeServiceGroups;
    },
    SET_TOTAL: (state, total) =>{
        state.total = total
    },
}